import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { questionnaireActions } from '../reducer/questionnaire-reducer';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion';
import { LOGIN_STATUS, authSelectors } from '@rosetta/react-auth';
import styled from '@emotion/styled';
import { appMainBackground, lightBlueColor, white } from '../../../styles/colors';
import { getAvailableInterfaceLanguages } from '../../app/services/language-helpers';
import { appActions, appSelectors } from '../../app/reducer/app-reducer';
import { RSDropdown } from '@rosetta/rs-dropdown';
import { menuStyle } from '../../../styles/InterfaceLanguageMenuDropdownStyle';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import mobileMyGoalsImage from '../../../assets/images/icon_duration.svg';
import { isMobile as isMobileDetected } from 'react-device-detect';
import { getTargetLanguageCode } from '../../app/util/user-helper';

const QuestionnaireContentWrapper = styled.div({
  backgroundColor: lightBlueColor,
  color: white,
  marginTop: '-30px',
  padding: '20px 0 10px',
  width: '100%'
});

const LaunchQuestionnaireView = styled.div((props) => {
  let style = {};
  return style;
});

const QuestionnnaireWrapper = styled.div((props) => {
  let style = {
    margin: ' auto',
    position: 'relative',
    textAlign: 'left',
    width: !props.isMobile ? '1000px' : 'auto'
  };
  return style;
});

const QuestionnaireContent = styled.div((props) => {
  let style = {
    boxSizing: 'border-box',
    display: 'block',
    padding: !props.isMobile ? '20px 100px 40px 100px' : '50px 16px 20px'
  };
  return style;
});

const QuestionnaireHeaderTranslate = styled.div({
  marginTop: '15px',
  width: '100%',
  textAlign: 'center'
});

const QuestionnaireTranslateLabel = styled.span({
  display: 'inline-block',
  fontSize: '12px',
  marginTop: '6px',
  verticalAlign: 'top'
});

const QuestionnaireLocaleSelector = styled.div({
  display: 'inline-block',
  height: '28px',
  left: '7px',
  width: 145,
  position: 'relative',
  textAlign: 'left'
});

const QuestionnaireHeader = styled.div((props) => {
  let style = {
    fontSize: !props.isMobile ? '32px' : '20px',
    fontWeight: '700',
    letterSpacing: '1px',
    margin: !props.isMobile ? '40px 0px 9px' : '10px 0'
  };
  return style;
});

const QuestionnaireDescription = styled.div((props) => {
  let style = {
    boxSizing: 'border-box',
    display: 'block',
    fontSize: !props.isMobile ? '22px' : '16px',
    lineHeight: !props.isMobile ? '32px' : '24px'
  };
  return style;
});

// Make strong
const QuestionnaireTimeLabel = styled.div((props) => {
  let style = {
    fontSize: !props.isMobile ? '18px' : '14px',
    fontWeight: '700',
    textAlign: !props.isMobile ? 'left' : 'center',
    marginTop: !props.isMobile ? '30px' : '-10px'
  };
  return style;
});

const QuestionnaireTimeEstimate = styled.div((props) => {
  let style = {
    color: lightBlueColor,
    fontSize: '32px',
    fontWeight: '200',
    lineHeight: '32px',
    marginTop: '18px',
    textAlign: !props.isMobile ? 'left' : 'center'
  };
  return style;
});

const MyGoalsMobileIcon = styled.div((props) => {
  let style = {
    display: 'inline-block',
    height: '32px',
    width: '32px',
    backgroundImage: 'url(' + mobileMyGoalsImage + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '32px 32px',
    backgroundPosition: '',
    verticalAlign: 'top',
    marginRight: '10px'
  };

  return style;
});

const QuestionnaireLaunch = styled.div((props) => {
  let style = {
    backgroundColor: appMainBackground,
    padding: !props.isMobile ? '' : '16px',
    width: !props.isMobile ? '1000px' : 'auto',
    margin: 'auto',
    textAlign: !props.isMobile ? 'left' : 'center',
    height: '1%',
    zoom: '1'
  };
  return style;
});

const QuestionnaireLaunchButton = styled.div((props) => {
  let style = {
    backgroundColor: lightBlueColor,
    backgroundImage: 'none',
    border: 'none',
    borderRadius: '8px',
    color: white,
    cursor: 'pointer',
    display: 'inline-block',

    fontFamily: 'inherit',
    fontSize: '14px',
    height: '41px',
    letterSpacing: '1px',
    lineHeight: '38px',
    margin: !props.isMobile ? '0 0 0 100px' : '',
    padding: '0 40px',
    textAlign: 'center',
    width: !props.isMobile ? 'auto' : '100%'
  };
  return style;
});

export class LaunchQuestionnaire extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleStart = () => {
    this.props.setLaunchPageViewed(true);
  };

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.isAppInitialized && nextProps.loginStatus !== LOGIN_STATUS.LOGGED_IN) {
      nextProps.history.push('/login');
    }
    return null;
  };
  handleInterfaceLanguageSelected = (languageObj) => {
    this.props.setInterfaceLanguage(languageObj.value);
  };

  render = () => {
    const isMobile = isMobileDetected ? true : false;
    if (!this.props.lionLoaded || this.props.loginStatus !== LOGIN_STATUS.LOGGED_IN) {
      return null;
    }

    const learningLanguageCode = getTargetLanguageCode(this.props.userInfo);
    const localizedL2Name = learningLanguageCode
      ? this.props.getLionTranslatedString('quest_full_language_' + learningLanguageCode)
      : '';
    return (
      <LaunchQuestionnaireView windowHeight={this.props.clientHeight} windowWidth={this.props.clientWidth}>
        <QuestionnaireContentWrapper>
          <QuestionnnaireWrapper data-qa="QuestionnnaireWrapper" isMobile={isMobile}>
            <QuestionnaireContent data-qa="QuestionnaireContent" isMobile={isMobile}>
              <QuestionnaireHeader isMobile={isMobile}>
                <LionTranslate lionkey="quest_heading" placeholders="L2" values={localizedL2Name} />
              </QuestionnaireHeader>

              <QuestionnaireDescription isMobile={isMobile}>
                <LionTranslate lionkey="quest_desc_header" placeholders="L2" values={localizedL2Name} />
              </QuestionnaireDescription>
            </QuestionnaireContent>
          </QuestionnnaireWrapper>
        </QuestionnaireContentWrapper>

        <QuestionnnaireWrapper data-qa="QuestionnnaireWrapper" isMobile={isMobile}>
          <QuestionnaireContent data-qa="QuestionnaireContent" isMobile={isMobile}>
            <QuestionnaireTimeLabel isMobile={isMobile}>
              <LionTranslate lionkey="quest_est_time" />
            </QuestionnaireTimeLabel>

            <QuestionnaireTimeEstimate isMobile={isMobile}>
              <MyGoalsMobileIcon isMobile={isMobile} />
              <LionTranslate lionkey="quest_objectives_time" />
            </QuestionnaireTimeEstimate>
          </QuestionnaireContent>
        </QuestionnnaireWrapper>
        <QuestionnaireLaunch isMobile={isMobile}>
          <QuestionnaireLaunchButton data-qa="Questionnaire" onClick={() => this.handleStart()} isMobile={isMobile}>
            <LionTranslate lionkey="quest_start" />
          </QuestionnaireLaunchButton>
        </QuestionnaireLaunch>
        <QuestionnaireHeaderTranslate data-qa="QuestionnaireHeaderTranslate">
          <QuestionnaireTranslateLabel>
            <LionTranslate lionkey="quest_translate" />
          </QuestionnaireTranslateLabel>

          <QuestionnaireLocaleSelector data-qa="QuestionnaireLocaleSelector">
            <RSDropdown
              dataQa="InterfaceLanguageChooser"
              buttonText=""
              itemsList={getAvailableInterfaceLanguages()}
              itemDisplayProperty="nativeName"
              itemKeyProperty="value"
              onSelectionHandler={this.handleInterfaceLanguageSelected}
              selectedKey={this.props.currentLocale}
              isRtl={this.props.isInterfaceRtl}
              menuStyle={menuStyle}
            />
          </QuestionnaireLocaleSelector>
        </QuestionnaireHeaderTranslate>
      </LaunchQuestionnaireView>
    );
  };
}

const mapStateToProps = (state, ownprops) => ({
  isAppInitialized: appSelectors.isAppInitialized(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  getLionTranslatedString: (key) => lionSelectors.getLionTranslatedString(state, key),
  currentLocale: lionSelectors.getLionLanguage(state),
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  loginStatus: authSelectors.loginStatus(state),
  userInfo: authSelectors.userInfo(state)
});

const wrappedActions = {
  setLaunchPageViewed: questionnaireActions.setLaunchPageViewed,
  setInterfaceLanguage: appActions.setInterfaceLanguage
};

export const LaunchQuestionnaireContainer = connect(
  mapStateToProps,
  wrappedActions
)(withWindowDimensions(LaunchQuestionnaire));



// WEBPACK FOOTER //
// ./src/modules/questionnaire/components/LaunchQuestionnaire.jsx